import { ChangeDetectorRef, Component,OnInit, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  districtname: any;
  values: any;
  userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));

  enrolled_values: any;
  requestcourse!: FormGroup;
  grequestcourse!: FormGroup;
  totalCourses: number = 0;
  studentcountValue: number = 0;
  enrolledCourses: any;
newcourse:any;
  pastcourseslength: any;

   constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe, 
    public router:Router,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef) 
    {  }
  

   ngOnInit(): void {
    this.formInitialization();
    this.bottomFormInitialization();
    this.handleBackButtonForModal();

    this.districtname=JSON.parse(localStorage.getItem('user_district'));    
     
console.log(this.userForm);
    //   this.ApiService.StudentEnrolledCourse(this.userForm.id,this.userForm.district).subscribe((data) => {
    //   console.log(data,"checking");
    //   this.values = data;
    //   this.enrolled_values =this.values.length;
    // })

    //   this.ApiService.getStudentCourseList(this.userForm.district,this.userForm.id).subscribe((data) => {
    //   console.log(data,"checking");
    //   this.values = data;
    //   this.totalCourses = this.values.length;
    // })

    this.ApiService.getAllCourses().subscribe(
      (data) => {
        this.values = data; 
        this.totalCourses = this.values.length;
       
      },
      (error) => {
        this.spinnerService.hide(); // Hide spinner on error
      }
    );

    this.ApiService.getEnrolledCourses(this.userForm.id,this.permanent_token).subscribe(
      (response) => {
        if (response.status === 'success') {
          this.enrolledCourses = response.courses.length;
          const today = new Date(); 
          const pastCourses = response.courses.filter((course: any) => new Date(course.course_date) < today);
          this.pastcourseslength = pastCourses.length; 
        } else {
          console.error('Error fetching enrolled courses:', response.message);
        }
      },
      (error) => {
        console.error('API error:', error);
      }
    );
   }
   
   // Initialize the Request Course Form
  formInitialization() {
    this.requestcourse = this.fb.group({
      student_name: [{value:this.userForm?.name, disabled: true}],
      phone_no: [{value:this.userForm?.number, disabled: true}],
      college_name: [{value:this.userForm?.college_name, disabled: true}],
      grade: [{value:this.userForm?.grade, disabled: true}],
      district: [{value:this.userForm?.district, disabled: true}],
      user_id: [{value:this.userForm.id, disabled: true}],
      requestedCourse: ['',[Validators.required]],
      email: [{value:this.userForm?.email, disabled: true}],
      studentcount:[{value:1}]
    });
  }
  bottomFormInitialization(){
    this.grequestcourse = this.fb.group({
      student_name: [{value:this.userForm?.name, disabled: true}],
      phone_no: [{value:this.userForm?.number, disabled: true}],
      college_name: [{value:this.userForm?.college_name, disabled: true}],
      grade: [{value:this.userForm?.grade, disabled: true}],
      district: [{value:this.userForm?.district, disabled: true}],
      user_id: [{value:this.userForm.id, disabled: true}],
      requestedCourse: ['',[Validators.required]],
      email: [{value:this.userForm?.email, disabled: true}],
      studentcount: ['', [Validators.required, Validators.min(2), Validators.max(30)]],
      studentsArray: this.fb.array([]) // Initialize FormArray
    });
  }
  
  onSubmitRequestCourse() {
    const requestData = {
      user_id: this.userForm.id,
      requested_course: this.requestcourse.get('requestedCourse')?.value.trim(),
      student_count:1,
       students: [
      {
        studentName: this.userForm?.name,
        phoneNo: this.userForm?.number,
        email: this.userForm?.email
      }
    ]
    };
    this.spinnerService.show();  // Start spinner
    this.ApiService.saveGroupRequestedCourse(requestData).subscribe({
      next: response => {
        Swal.fire({
          title: 'Success!',
          text: 'Request Course details have been saved successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          window.location.reload();
          // this.router.navigate(['/student']); // Redirect after success
        });
      },
      error: error => {
        Swal.fire({
          title: 'Error!',
          text: 'There was an error saving the request!',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    });
  }
  onSubmitGroupRequestCourse(): void {
    const requestData = {
      user_id: this.userForm.id,
      requested_course: this.grequestcourse.get('requestedCourse')?.value?.trim() ?? '',
      student_count: this.grequestcourse.get('studentcount')?.value,
      students: this.studentsArray.value.map((student: any) => ({
        studentName: student.studentName ? student.studentName.trim() : '',
        phoneNo: student.phoneNo ? student.phoneNo.trim() : '',
        email: student.email ? student.email.trim() : ''
      }))
    };
  
    console.log('Request Data:', requestData); // Log the data being sent to the backend
    this.spinnerService.show();  // Start spinner
    this.ApiService.saveGroupRequestedCourse(requestData).subscribe({
      next: response => {
        Swal.fire({
          title: 'Success!',
          text: 'Group Course Request has been saved successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => {
          window.location.reload();  // Reload the page after success
        });
      },
      error: error => {
        Swal.fire({
          title: 'Error!',
          text: 'There was an error saving the group course request!',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    });
  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }
  
  // handleBackButtonForModal() {
  //   // Push initial state to history
  //   history.pushState(null, '', window.location.href);

  //     window.onpopstate = () => {
  //       const modal = document.querySelector('.modal.show') as HTMLElement;
  //       if (modal) {
  //         // Get the modal ID from the modal element
  //         const modalId = modal.id;
  //         this.closeModal(modalId);
  //         // Prevent default back navigation
  //         history.pushState(null, '', window.location.href);
  //     } else {
  //       // Allow back navigation as usual if modal is not open
  //       this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
  //     }
  //   };
  // }

  // closeModal(modalId: string) {
  //   //const modal = document.querySelector('#requestGroupCourseModal') as HTMLElement;
  //   const modal = document.querySelector(`#${modalId}`) as HTMLElement;

  //   if (modal) {
  //     // Remove 'show' class to hide modal
  //     modal.classList.remove('show');
  //    this.renderer.setStyle(modal, 'display', 'none');
  //     // Remove modal-open class from body
  //     this.renderer.removeClass(document.body, 'modal-open');
  //   // this.renderer.setStyle(document.body, 'overflow', 'auto');
  //    this.renderer.removeAttribute(modal, 'role');
  //   this.renderer.removeAttribute(modal, 'aria-modal');
  //    this.renderer.setAttribute(modal, 'aria-hidden', 'true');
  //   }
  //   // Remove the modal backdrop manually
  //  // const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
  //   const backdrops = document.querySelectorAll('.modal-backdrop');
  //  backdrops.forEach(backdrop => {
  //   //this.renderer.setStyle(backdrop, 'display', 'none');

  //   // Set opacity to 0 and hide the backdrop
  //     // Remove each backdrop from the DOM
  //     backdrop.remove();
  //   });
  //     //window.location.reload();
    
  // }
  
  // Formreset() {
  //   this.formInitialization();
  //   this.bottomFormInitialization();
  //      // Close the modal
  //   this.closeModal('requestCourseModal'); // Specify the ID of the modal you want to close
  //   this.closeModal('requestGroupCourseModal'); // Specify the ID of the other modal
   
    
  //   // Close the modal
  //  // this.closeModal();
  // }

  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }
  
  Formreset() {
    this.formInitialization();
    this.bottomFormInitialization();
    this.cdr.detectChanges();

     }

get studentsArray(): FormArray {
  return this.grequestcourse.get('studentsArray') as FormArray;
}

get studentsFormGroups(): FormGroup[] {
  return this.studentsArray.controls as FormGroup[];
}


onStudentCountChange(event: Event): void {
  const input = event.target as HTMLInputElement;
  const count = Number(input.value);
  this.studentcountValue = count;
  console.log('StudentsArray Value:', this.studentsArray.value); 
  // Clear existing form array
  this.studentsArray.clear();

  // Add new controls based on count
  for (let i = 0; i < count; i++) {
    // Define 'name' and 'phone' controls within each row's FormGroup
    this.studentsArray.push(this.fb.group(
      {
        studentName: ['', Validators.required],
        phoneNo: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]{10}$/)]],
        email: ['', [Validators.required,Validators.email]]
    }));
  }
  this.cdr.detectChanges();
}

 }
